export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}user/user/:id`;
    const profile = `${SEED_CORE.ENV.API_URL}user/profile/:id`;
    const licence = `${SEED_CORE.ENV.API_URL}user/licence-point/:id`;
    const importLog = `${SEED_CORE.ENV.API_URL}user/user/import-log/:importId`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        getUser: {
            method: 'POST',
            url: `${url}/get-user`,
            isArray: true
        },
        getUsers: {
            method: 'POST',
            url: `${url}/users`,
            isArray: true
        },
        updatePassword: {
            method: 'POST',
            url: `${profile}/update-password`
        },
        resetPassword: {
            method: 'POST',
            url: `${url}/reset-password`
        },
        resetPasswordPublic: {
            method: 'POST',
            url: `${url}/reset-password-public`
        },
        signUp: {
            method: 'POST',
            url: `${SEED_CORE.ENV.API_URL}user/user/sign-up`
        },
        setSiteRoles: {
            method: 'POST',
            url: `${url}/set-site-roles`
        },
        activateAccount: {
            method: 'POST',
            url: `${url}/activate-account`
        },
        activateAccountPublic: {
            method: 'POST',
            url: `${url}/activate-account-public`
        },
        activateAccountBulk: {
            method: 'POST',
            url: `${url}/request-account-activation-bulk`
        },
        activateExternalAccountBulk: {
            method: 'POST',
            url: `${url}/request-external-account-activation-bulk`
        },
        resetPasswordBulk: {
            method: 'POST',
            url: `${url}/reset-password-bulk`
        },
        importUsers: {
            method: 'POST',
            url: `${url}/import`
        },
        switchAdminLanguage: {
            method: 'POST',
            url: `${url}/switch-admin-language`
        },
        switchCoursyLocale: {
            method: 'POST',
            url: `${url}/switch-coursy-locale`
        },
        courses: {
            method: 'GET',
            url: `${url}/courses`,
            isArray: true
        },
        trainingNeedUserCourses: {
            method: 'GET',
            url: `${url}/training-need-user-courses`,
            isArray: true
        },
        setTrainingNeed: {
            method: 'POST',
            url: `${url}/set-training-need`
        },
        plannedUsers: {
            method: 'POST',
            url: `${url}/planned-users`,
            isArray: true
        },
        licences: {
            method: 'GET',
            url: `${licence}/list`,
            isArray: true
        },
        licencePoints: {
            method: 'POST',
            url: `${licence}/search`,
            isArray: true
        },
        assignLicencePoint: {
            method: 'POST',
            url: `${licence}/assign`,
            isArray: true
        },
        updateLicencePoint: {
            method: 'PUT',
            url: `${licence}`
        },
        deleteLicencePoint: {
            method: 'DELETE',
            url: `${licence}`
        },
        importLog: {
            method: 'GET',
            url: `${importLog}`
        },
        licenceReport: {
            method: 'POST',
            url: `${licence}/report`,
            isArray: true
        },
        anonymizeEmployees: {
            method: 'POST',
            url: `${url}/anonymize-employees`
        },
        deanonymizeEmployee: {
            method: 'POST',
            url: `${url}/deanonymize-employee`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/User/index.js